import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Migratie controller connected")
  }

  switchTab(event) {
    console.log("switchTab called", event.currentTarget.dataset.tab)
    event.preventDefault()

    const targetTab = event.currentTarget.dataset.tab

    // Remove active state from all tab buttons
    const tabButtons = this.element.querySelectorAll('.tab-button')
    tabButtons.forEach(button => {
      button.classList.remove('border-blue-500', 'text-blue-600')
      button.classList.add('border-transparent', 'text-gray-500')
      button.removeAttribute('aria-current')
    })

    // Add active state to clicked tab button
    event.currentTarget.classList.remove('border-transparent', 'text-gray-500')
    event.currentTarget.classList.add('border-blue-500', 'text-blue-600')
    event.currentTarget.setAttribute('aria-current', 'page')

    // Hide all tab content
    const tabContents = this.element.querySelectorAll('.tab-content')
    tabContents.forEach(content => {
      content.classList.add('hidden')
    })

    // Show target tab content
    const targetContent = this.element.querySelector(`#${targetTab}`)
    if (targetContent) {
      targetContent.classList.remove('hidden')
    }
  }

  toggleFaq(event) {
    console.log("toggleFaq called", event.currentTarget.dataset.faq)
    event.preventDefault()

    const targetFaq = event.currentTarget.dataset.faq
    const faqContent = this.element.querySelector(`#${targetFaq}`)
    const faqIcon = event.currentTarget.querySelector('.faq-icon')

    if (faqContent && faqIcon) {
      if (faqContent.classList.contains('hidden')) {
        // Show FAQ
        faqContent.classList.remove('hidden')
        faqIcon.classList.add('rotate-180')
      } else {
        // Hide FAQ
        faqContent.classList.add('hidden')
        faqIcon.classList.remove('rotate-180')
      }
    }
  }
}